import React from 'react'
import {
  ROUTE_CHANGE,
  RATE_MY_SERVICE_MODAL_CHANGE,
  RATE_MY_SERVICE_RATED,
  RATE_MY_SERVICE_QUESTIONS,
} from '../../constants/ratings'
import { IRateMyServiceState } from '../../interfaces/ratings'
import { getSubmitButtonStatus } from '../../utils/ratingsUtils'

export const initialServiceState: IRateMyServiceState = {
  rateMyService: {
    rmsResponse: {
      id: '',
      country: '',
      useCaseType: '',
      language: '',
      ratingType: '',
      ratingMinValue: 1,
      ratingMaxValue: 1,
      questions: [
        {
          id: '',
          questionText: '',
          answerType: '',
          isAnswerRequired: true,
          isEnabled: true,
          options: [
            {
              optionKey: '',
              optionValue: '',
            },
          ],
        },
      ],
      ratingThreshold: 1,
      createDate: '',
      lastModifiedDate: '',
      ratingTitle: '',
    },
    isSubmitButtonDisabled: true,
    comment: '',
    isShowing: false,
    isShowOldModal: false,
    score: 0,
    skipped: false,
    answers: [{ questionId: '', responses: [] }],
    modalStatus: 'initial',
    survey: {},
    surveyError: false,
    loadingFeedBack: false,
    ratingThreshold: null,
    submittedMessage: '',
    isVisibleQuestions: undefined,
  },
  rated: [],
}

const rateMyServiceReducer = (state = initialServiceState, action) => {
  const { payload, type } = action
  switch (type) {
    case RATE_MY_SERVICE_MODAL_CHANGE:
      return {
        ...state,
        rateMyService: {
          ...state.rateMyService,
          ...payload,
        },
      }
    case RATE_MY_SERVICE_QUESTIONS:
      if (!payload || !payload.answers || !state.rateMyService) {
        return state
      }
      const updatedAnswers = state.rateMyService.answers.map(
        (answer) =>
          payload.answers.find((a) => a.questionId === answer.questionId) ||
          answer
      )
      const newAnswers = payload.answers.filter(
        (a) =>
          !state.rateMyService.answers.some(
            (answer) => answer.questionId === a.questionId
          )
      )

      const mergedAnswers = [...updatedAnswers, ...newAnswers]
      const isSubmitButtonDisabled = getSubmitButtonStatus(
        state?.rateMyService?.requiredQuestions,
        mergedAnswers
      )

      return {
        ...state,
        rateMyService: {
          ...state.rateMyService,
          isSubmitButtonDisabled: !isSubmitButtonDisabled,
          answers: mergedAnswers,
        },
      }

    case RATE_MY_SERVICE_RATED:
      return {
        ...state,
        rated: [...state.rated, payload.ticketNumber],
      }
    case ROUTE_CHANGE:
      return initialServiceState
    default:
      return state
  }
}

export default rateMyServiceReducer
